import React from 'react';
import { Divider } from '@material-ui/core';
import styled from 'styled-components';
import { COLORS } from '../../constants';

const ChatDivider = React.memo(styled(Divider)`
  background-color: ${COLORS.GREY_H};
`);

export default ChatDivider;
